/**
 * For accessing local storage
 * @return username from local storage
 */
const useLocalStorage = {
    getUsernameFromLocalStorage(): string {
        return localStorage.getItem('alias') as string;
    }
};

export default useLocalStorage;
